import React, { Component } from 'react';
import axios from 'axios';
import {QRCodeCanvas} from 'qrcode.react';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Akne extends Component {


  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      eligardsunumname: '',
      hippurinsunumname: '',
      colchicumsunumname: '',
      success: '',
      error: '',
      getuuid: '',
      gettype: '',
      eligarddisabled: false,
      hippurindisabled: false,
      field_group: '',
      count: 180
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEligardSubmit = this.handleEligardSubmit.bind(this);
    this.handleHippurinSubmit = this.handleHippurinSubmit.bind(this);
    this.handleColchicumSubmit = this.handleColchicumSubmit.bind(this);
  }


  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value
    })
  }

  handleEligardSubmit(event) {
   	const timestamp = Date.now();
    event.preventDefault();
  
  	var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var csrf_token = localStorage.getItem('csrf_token');
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');
  
    var self = this;
  	
    console.log('Your input value is: ' + this.state.eligardsunumname)

  	console.log(uid);
  	console.log(auth);
  	//console.log(username);
  	//console.log(logout_token);

	var axiosConfig = {
  		headers: {
        'Content-Type': 'application/json',
      	'X-CSRF-Token': csrf_token,
        "Authorization":"Basic Zm9jdXM6SDg3MzczMjNu",
  		}
	};
	
  	//console.log(timestamp);
	//console.log(auth);

  
    axios.post('https://api.recordatifocus.com/node/?_format=json', {
      type: [{"target_id":"eligard"}],
      title: [{"value": this.state.eligardsunumname}],
      body: [{"value": this.state.body}],
      uid: [{"target_id": uid}]
    }, axiosConfig)
    .then(function (response) {
    
      //console.log(response);
	  //console.log(response.data.uuid["0"].value)
    
      self.setState({
      	gettype: 'eligard',
        getuuid: response.data.uuid["0"].value,
        'success': 'Message sent getuuid',
        'error': ''
      });
    
      var eligard = response.data.uuid["0"].value;
      console.log(eligard);
      axios.post(`https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/eligard/${eligard}&keyword=${eligard}`, axiosConfig);
      axios.post('https://api.recordatifocus.com/not.php', axiosConfig);
    
    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');

      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
 
    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: 'Sunuma geçiniz'
        }); 
      } else {
        this.setState((prevState) => ({count: prevState.count - 1})); 
      }
    }, 1000);

      self.setState({
        eligarddisabled: true
      });
  }











  handleColchicumSubmit(event) {
   	const timestamp = Date.now();
    event.preventDefault();
  
  	var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var csrf_token = localStorage.getItem('csrf_token');
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');
  
    var self = this;
  	
    console.log('Your input value is: ' + this.state.colchicumsunumname)

  	console.log(uid);
  	console.log(auth);
  	//console.log(username);
  	//console.log(logout_token);

	var axiosConfig = {
  		headers: {
        'Content-Type': 'application/json',
      	'X-CSRF-Token': csrf_token,
        "Authorization":"Basic Zm9jdXM6SDg3MzczMjNu",
  		}
	};
	
  	//console.log(timestamp);
	//console.log(auth);

  
    axios.post('https://api.recordatifocus.com/node/?_format=json', {
      type: [{"target_id":"colchicum"}],
      title: [{"value": this.state.colchicumsunumname}],
      body: [{"value": this.state.body}],
      uid: [{"target_id": uid}]
    }, axiosConfig)
    .then(function (response) {
    
      //console.log(response);
	  //console.log(response.data.uuid["0"].value)
    
      self.setState({
      	gettype: 'colchicum',
        getuuid: response.data.uuid["0"].value,
        'success': 'Message sent getuuid',
        'error': ''
      });
    
      var colchicum = response.data.uuid["0"].value;
      console.log(colchicum);
      axios.post(`https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/colchicum/${colchicum}&keyword=${colchicum}`, axiosConfig);
      axios.post(`https://api.recordatifocus.com/not.php?id=${colchicum}&sunumadi=colchicum&uid=${uid}`, axiosConfig);

    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');

      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
 
    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: 'Sunuma geçiniz'
        }); 
      } else {
        this.setState((prevState) => ({count: prevState.count - 1})); 
      }
    }, 1000);

      self.setState({
        eligarddisabled: true
      });
  }










  handleHippurinSubmit(event) {
   	const timestamp = Date.now();
    event.preventDefault();
  
  	var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var csrf_token = localStorage.getItem('csrf_token');
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');
  
    var self = this;
  	
    console.log('Your input value is: ' + this.state.hippurinsunumname)

  	//console.log(uid);
  	//console.log(csrf_token);
  	//console.log(username);
  	//console.log(logout_token);

	var axiosConfig = {
  		headers: {
        'Content-Type': 'application/json',
      	'X-CSRF-Token': csrf_token,
        "Authorization":"Basic Zm9jdXM6SDg3MzczMjNu",
  		}
	};
	
  	//console.log(timestamp);

    axios.post('https://api.recordatifocus.com/node/?_format=json', {
      type: [{"target_id":"hippurin"}],
      title: [{"value": this.state.hippurinsunumname}],
      body: [{"value": this.state.body}],
      uid: [{"target_id": uid}]
    }, axiosConfig)
    .then(function (response) {
    
      //console.log(response);
	 // console.log(response.data.uuid["0"].value)
    
      self.setState({
      	gettype: 'hippurin',
        getuuid: response.data.uuid["0"].value,
        hippurindisabled: true,
        'success': 'Message sent getuuid',
        'error': ''
      });
    
      console.log(response.data.uuid["0"].value);
      
      var hipuuid = response.data.uuid["0"].value;
      console.log(hipuuid);
    
      axios.post(`https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/hippurin/${hipuuid}&keyword=${hipuuid}`, axiosConfig);
      axios.post(`https://api.recordatifocus.com/not.php?keyword${hipuuid}&keyword=${hipuuid}&uid=${uid}`, axiosConfig);

    })
  
 
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');

      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  
    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: 'Sunuma geçiniz'
        }); 
      } else {
        this.setState((prevState) => ({count: prevState.count - 1})); 
      }
    }, 1000);

        self.setState({
        hippurindisabled: true
      });

  }





  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span className="">
          <NavLink className="d-none me-2 small link-dark text-decoration-none" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="small link-dark text-decoration-none" to="/user/logout">
            <i className="fa fa-sign-out"></i> Çıkış
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }




  componentDidMount() {
   var uid = localStorage.getItem('uid');
   console.log(uid);
    var self = this;
    this.serverRequest = axios.get('https://api.recordatifocus.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic Zm9jdXM6SDg3MzczMjNu"}
    })
    .then(function(result){
      self.setState({
        field_group: result.data.field_group["0"].target_id
      });
    })
  console.log(this.result);
  }



  render(){
    var loggedIn = localStorage.getItem('auth');
  
  	var gruopcode = this.state.field_group;
  
	let group;
    let urunbir;

    if (this.state.field_group == 5) {
      group = <span>{this.state.field_group} -  Kardiyoloji</span>
      urunbir = "Yonlendirme";
    } 

  
    if (loggedIn) {
    if (this.state.field_group === 5) {
        return (
          <div className="row pt-5 position-relative">
              
        
            <div className="col-lg-3 mb-5 mb-lg-0">
            <div className="mb-2 d-flex justify-content-between p-2 bg-white rounded-3">
            {this.renderUserName()} <div className="d-none">{gruopcode} {group}</div> {this.renderUserLinks()}
            </div>
            <NavLink  className="btn btn-sorularim w-100 mb-4" to="/user/profile">Sunumlarım</NavLink>
            <div>
            </div>
            
            
            
			<div className="mb-5">
            	<div className="border mb-3 bg-white rounded-3 border-1">
                	<img className="px-2 py-2 img-fluid" style={{ maxHeight: '64px', width: 'auto' }} src="/images/cabral.png"/>
            	</div>
              	<form className="text-center mb-2" onSubmit={this.handleColchicumSubmit}>
                	<input name="colchicumsunumname" required type="text" className="form-control mb-2" placeholder="Sunum Adı-Yeri" onChange={this.handleChange} />
                	<button type="submit" className="btn btn-cabral w-100" disabled={ this.state.eligarddisabled }>Cabral Soru Oluştur</button>
              	</form>
                       
            </div>
            
			<div className="mb-5">
            	<div className="border mb-3 bg-white rounded-3 border-1">
                	<img className="px-2 py-2 img-fluid" style={{ maxHeight: '64px', width: 'auto' }} src="/images/prepagel.png"/>
            	</div>
              	<form className="text-center mb-2" onSubmit={this.handleColchicumSubmit}>
                	<input name="colchicumsunumname" required type="text" className="form-control mb-2" placeholder="Sunum Adı-Yeri" onChange={this.handleChange} />
                	<button type="submit" className="btn btn-prepagel w-100" disabled={ this.state.eligarddisabled }>Prepagel Soru Oluştur</button>
              	</form>
                       
            </div>
            
			<div className="mb-5">
            	<div className="border mb-3 bg-white rounded-3 border-1">
                	<img className="px-2 py-2 img-fluid" style={{ maxHeight: '64px', width: 'auto' }} src="/images/kreval.png"/>
            	</div>
              	<form className="text-center mb-2" onSubmit={this.handleColchicumSubmit}>
                	<input name="colchicumsunumname" required type="text" className="form-control mb-2" placeholder="Sunum Adı-Yeri" onChange={this.handleChange} />
                	<button type="submit" className="btn btn-kreval w-100" disabled={ this.state.eligarddisabled }>Kreval Soru Oluştur</button>
              	</form>
                       
            </div>
            
            
            
            
            
            
            
            </div>
                <div className="col-lg-9 text-center">
                  <p className="success d-none">{this.state.success}</p>
                  <p className="title d-none">{this.state.getuuid}</p>
                  <div className="mb-4">
					{!this.state.getuuid && <div className="text-center">Soru oluşturunuz!</div>}
                  	{this.state.getuuid && <a href={`https://qr.recordatifocus.com/${this.state.getuuid}`} target="_blank"><div className="p-3 bg-white rounded-3 d-inline-flex"><QRCodeCanvas value={`https://sorular.recordatifocus.com/${this.state.gettype}/${this.state.getuuid}`} size="320"/></div></a>}
                  </div>
                  

			      {this.state.getuuid && <h2 className="mb-3">{this.state.sunumageciniz ? this.state.sunumageciniz : this.state.count}</h2>}


                  <div className="row justify-content-center">
                  	<div className="col-lg-4">
                	  {this.state.getuuid && <a target="_blank" className={`w-100 btn btn-${this.state.gettype}`} href={`https://slide.recordatifocus.com/${this.state.gettype}/${this.state.getuuid}`}>Sunuma Başla</a>}
                    </div>
                  
                  

                  
                  
                    <p className="error" dangerouslySetInnerHTML={{__html: this.state.error}} />

                  </div>
                <div className="cube-code bottom-0 end-0 translate-middle-y d-inline-flex"><p className="p-0 small text-center rotated">3</p></div>
                </div>
	        
          </div>
		  
        );
    }
    } else {
        return (
          <div className="row top-buffer">
        			<Redirect to="/user/login" />
          </div>
        );
    }
  }
}

export default Akne



// WEBPACK FOOTER //
// src/components/agri.jsx